export enum ModalPointsStateType {
  POINTS_AVAILABLE = 'pointsAvailable',
  NO_POINTS_AVAILABLE = 'noPointsAvailable',
  POINTS_APPLIED = 'pointsApplied',
}
